export function DailyRevenueShimmer() {
  const bars = Array.from({ length: 7 });

  return (
    <>
      <div className="w-full h-[350px] flex items-end gap-2">
        {bars.map((_, idx) => {
          const height = Math.floor(Math.random() * 150) + 50;
          return (
            <div
              key={idx}
              className="flex-1 bg-gray-200 rounded-t-lg animate-pulse"
              style={{ height: `${height}px` }}
            />
          );
        })}
      </div>

      <div className="mt-4 flex justify-between text-gray-300 text-sm">
        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day, idx) => (
          <div key={idx} className="w-6 h-4 bg-gray-200 rounded" />
        ))}
      </div>
    </>
  );
}
